import { useState, useEffect, useContext, useRef } from 'react'
import { useForm } from 'react-hook-form'
import Modal from 'react-modal'
import axios from 'axios'
import axio from 'axios'

import { projectContext, loadingContext, unfolder, openAlert, useTranslate } from '../lib'
import { SelectNesting } from './common/Inputs/Select'
import { urlValue } from '../lib'
import '../styles/styles.css'
import '../styles/newProjectModal.scss'
import { customModal } from '../styles/customModal'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { Alerts } from './common/Alerts'
export default function NewCampaingModal({ isModalOpen,  closeModal }) {
  const [loading, setLoading] = useContext(loadingContext)
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [error, setError] = useState({ name: "" })
  const [region, setRegion] = useState([])
  const { t } = useTranslate();
  const regionRef = useRef();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    (async () => {
      await fetchRegion();
      
    })()

  }, []);
  
  const fetchRegion = async () => {
    console.log("Ingreso")
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    // setLoading(true)
    try {
      const url = `${urlValue}/studio/campaign/regions`;
      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      });

      if (rest.status === 200 && rest.data) {
        setRegion(rest.data)
      }
      return rest;
    } catch (error) {
      console.log(error)
      return error;
    }
  }
 
  const onSubmit = async data => {

    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g;
    if (!exp.test(data.name)) {
      ok = false;
      setError({ ...error, name: t('errors.nameInvalid') })
    }

    if (ok) {
      const dataSend = {
        name: data.name,
        country: data.country,
        region_id: regionRef.current?.value || 1,
        id: isModalOpen?.campaing?.campaing_id || 0
      }

      axios({
        method:  'post',
        url: `${urlValue}/studio/campaign`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          closeModal()
          setLoading(false)
          window.location.href = "/campaigns";
          
        })
        .catch(function (error) {
          if (error.response.status == 409) {
            openAlert('#alert-ac', () => { setAlert({ title: error?.response?.data?.message, visible: true, error: true }) }, 5000,
            () => { setAlert({ ...alert, visible: false }) });
          }
          else {
            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.campaignNotSaved'), visible: true, error: true }) }, 4000,
            () => { setAlert({ ...alert, visible: false }) });
          }          
          setLoading(false)
          // closeModal()
        })
    }
  }

  return (
    // <Modal  isOpen={isModalOpen.newCampaing} style={{...customModal, width: "40%"}} ariaHideApp={false}>
      <div className="newProject-modal newCampaing-modal"   >
        <h1>{  t('menu.createCampaign')  }</h1>
        <form onSubmit={handleSubmit(onSubmit)} style={{width: '100%'}}>
          <div className="inputs" id="name">
            <div className="input tooltip">
              <span>{t('common.name')}:</span>
              <input placeholder={t('menu.newCampaignName')} className='input-data' id='namecp-tp' {...register('name', { required: true })}    type="text" />
              {/* <span className="tooltiptext">Only these characters are accepted A-Za-z0-9-,._'¿?<div className='triangulo'></div></span> */}
              <Tooltip   anchorId="namecp-tp" content={t('alerts.charactersNameTooltip')} place="top" />
            </div>
            <SelectNesting
              ref={regionRef} id="region" //onChange={saveBotSentimentConfig}
              boxInfo={true} tooltipText={t('menu.regionForCampaign')}
              title="Region:" containerClass="mr-1" style={{ minWidth: 150 }}
            >
              {region?.map((item, index) => (<option key={`region ${index + 1}:`} value={item.id}>{item.name}</option>))}
            </SelectNesting>
            <div className="input tooltip">
              <span>{t('common.country')}:</span>
              <input placeholder={t('menu.countryName')} className='input-data' id='country' {...register('country', { required: true })}    type="text" />
              <Tooltip   anchorId="country" content={t('alerts.charactersCountryNameTooltip')} place="top" />
            </div>
          </div>

          <div className="footer">
            <div className='cont-buttons'>
              {errors.name?.type === 'required'
                ? (
                  <span style={{ color: "red" }}>{t('menu.fieldsRequired')}</span>
                ) : (
                  <span> </span>
                )}
              <span className='errors-msg'  >{error.name}</span>
            </div>
            <div className='cont-buttons' style={{marginTop: 25}}>
              <div className="buttons">
                <button className="cancel btn-bottom btn-bottom-cancel" type="button" onClick={() => closeModal()}>
                  {t('common.cancel')}
                </button>
                <button className="create btn-bottom btn-bottom-create " type="submit">
                  { t('common.create')}
                </button>
              </div>

            </div>
          </div>

        </form>
        {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error}/>}
      </div>
    // </Modal>
  )
}
